export default () => navigator.userAgent.match(/Node\.js/i) && window && window.reactSnapshotRender



// WEBPACK FOOTER //
// ./src/isBeingCrawledByReactSnapshot.js